<div class="bg-card shadow rounded-2xl overflow-hidden m-4 w-full">
    <!-- Header -->
    <div class="flex justify-between p-5 px-8 bg-primary">
        <div class="text-3xl text-white self-center"><b>
                {{ field?.longName || field?.name }}
            </b></div>

        <div class="flex">
            <button class="btn btn-outline font-medium mr-2 border-white" style="color: white;"
                (click)="addPlatformModal(field)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="white" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Create Platform
            </button>

            <button class="btn btn-outline font-medium border-yellow" style="color: yellow"
                (click)="editFieldModal(field)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="yellow" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                </svg>
                Edit
            </button>
        </div>
    </div>

    <div class="px-3 m-6 ">
        <div class="grid grid-cols-1 sm:grid-cols-2 py-3 gap-6 ">
            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Field Name
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.longName }}
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Region
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.region }}
                </div>
            </div>
        </div>

        <hr class="my-1" style="color: rgb(213, 213, 213);">

        <div class="grid grid-cols-1 sm:grid-cols-2 py-3 gap-6 ">
            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Company Name
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.companyName }}
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Status
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.status }}
                  </div>
            </div>
        </div>

        <hr class="my-1" style="color: rgb(213, 213, 213);">

        <div class="grid grid-cols-1 sm:grid-cols-2 py-3 gap-6 ">
            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Block
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.block }}
                </div>
            </div>

            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Created Date
                </div>
                <div class="flex-grow greyText self-center">
                    {{ handleDateFormat(field?.createdDate) }}
                </div>
            </div>
        </div>

        <hr class="my-1" style="color: rgb(213, 213, 213);">

        <div class="grid grid-cols-1 sm:grid-cols-2 py-3 gap-6 ">
            <div class="flex flex-col sm:flex-row">
                <div class="w-full md:w-36 sm:w-auto self-center">
                    Remarks
                </div>
                <div class="flex-grow greyText self-center">
                    {{ field?.remarks }}
                </div>
            </div>
        </div>
    </div>
</div>